import React from "react";
import { isRegPortal } from "shared/utils/config";
import RegistrationStripeRedirect from "./registration";
import { useSearchParams } from "react-router-dom";
import { STRIPE_PAYMENT_SUCCESS_LIST, StripePaymentStatus } from "shared/components/payment/enum";
import { useMakePayment } from "shared/dataloader";
import { RedirectQueryParam } from "shared/enums/Redirect";
import { getErrorMessage } from "shared/utils/network";
import { errorToast } from "shared/utils/toastNotification";
import MyExperienceStripeRedirect from "./myexperience";

export default function StripeRedirect() {
  const [searchParams] = useSearchParams();
  const [displayRetryMsg, setDisplayRetryMsg] = React.useState<boolean>(false);

  const isStripeRedirectStatusSuccess = React.useMemo(() => {
    return STRIPE_PAYMENT_SUCCESS_LIST.includes(
      searchParams.get(RedirectQueryParam.STRIPE_REDIRECT_STATUS) as StripePaymentStatus
    );
  }, [searchParams]);

  // error handler if pay api fails
  const makeStripePaymentErrorHandler = React.useCallback(err => {
    const timeoutId = setTimeout(() => {
      errorToast(getErrorMessage(err));
      setDisplayRetryMsg(true);
      clearTimeout(timeoutId);
    }, 1000);
  }, []);

  const {
    mutateAsync: makePayment,
    error: makePaymentError,
    isLoading,
    isSuccess,
    isError,
    data: makePaymentResponse
  } = useMakePayment({ hideLoader: true, errorHandler: makeStripePaymentErrorHandler });

  React.useEffect(() => {
    if (isLoading) {
      setDisplayRetryMsg(false);
    }
  }, [isLoading]);

  const displayLoader = React.useMemo(() => {
    // will display loader in following conditions:
    // 1. we are making api call
    // 2. 1 second delay once we get error in pay api response (1s delay is controlled by displayRetryMsg in StripeRedirect component)
    return Boolean(
      isLoading || (!isSuccess && !isError && isStripeRedirectStatusSuccess) || (makePaymentError && !displayRetryMsg)
    );
  }, [displayRetryMsg, isError, isLoading, isStripeRedirectStatusSuccess, isSuccess, makePaymentError]);

  return isRegPortal ? (
    <RegistrationStripeRedirect
      isStripeRedirectStatusSuccess={isStripeRedirectStatusSuccess}
      makePayment={makePayment}
      makePaymentError={makePaymentError}
      displayLoader={displayLoader}
    />
  ) : (
    <MyExperienceStripeRedirect
      isStripeRedirectStatusSuccess={isStripeRedirectStatusSuccess}
      makePayment={makePayment}
      makePaymentError={makePaymentError}
      displayLoader={displayLoader}
      makePaymentResponse={makePaymentResponse}
    />
  );
}
